// extracted by mini-css-extract-plugin
export default {"callback":"RegularCD_callback__PuhBT","callbackInfo":"RegularCD_callbackInfo__9fsQj","callbackForm":"RegularCD_callbackForm__8D7G6","crossWrapper":"RegularCD_crossWrapper__qIRKk"};